// extracted by mini-css-extract-plugin
export default {"configForm":"configForm---rYj_z"};